function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2999"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-ios-play-circle",
    d: "M15.375 3.375a12 12 0 1 0 12 12 12 12 0 0 0-12-12zM20.21 15.6l-7.915 4.788a.257.257 0 0 1-.387-.225v-9.576a.256.256 0 0 1 .387-.225l7.915 4.788a.264.264 0 0 1 0 .45z",
    transform: "translate(-3.375 -3.375)",
    style: {
      fill: "#07aa3f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconGreen);
export default __webpack_public_path__ + "static/media/playIconGreen.01b9887346b290cd7bf7c1d159638c97.svg";
export { ForwardRef as ReactComponent };